import { useTranslate } from '@repo/shared/hooks'
import { z } from 'zod'

export const useEditProfileSchema = () => {
  const { t } = useTranslate()

  const schema = z.object({
    fullName: z.string().min(1, t('editProfile_validation_fullName_required')),
    username: z.string().optional(),
    agencyName: z
      .string()
      .min(1, t('editProfile_validation_agencyName_required')),
    agencyAddress: z
      .string()
      .min(1, t('editProfile_validation_agencyAddress_required')),
    instagram: z
      .string()
      .optional()
      .refine(
        (v) => !v || /^[a-zA-Z0-9._]{3,30}$/.test(v),
        t('editProfile_validation_instagram_invalid'),
      ),

    telegram: z
      .string()
      .optional()
      .refine(
        (v) =>
          !v ||
          /^[a-zA-Z0-9_]{5,32}$/.test(v) || // telegram id
          /^09\d{9}$/.test(v), // phone
        t('editProfile_validation_telegram_invalid'),
      ),

    whatsapp: z
      .string()
      .optional()
      .transform((v) => v?.replace('+98', '0'))
      .refine(
        (v) => !v || /^09\d{9}$/.test(v),
        t('editProfile_validation_whatsapp_invalid'),
      ),
  })

  return { schema }
}
export type EditProfileFormValues = z.infer<
  ReturnType<typeof useEditProfileSchema>['schema']
>
